export class UserError extends Error {
  constructor() {
    super()
    this.name = 'User Error'
  }

  isMissing() {
    this.message = 'No user was found in the user service'
    return this
  }
}
